import { AppSidebar } from '@/components/app-sidebar'
import { PropsWithChildren } from 'react'
import { UserProvider } from './user-provider'
import { HeaderUser } from '@/components/header-user'
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'
import { TooltipProvider } from '@/components/ui/tooltip'

const EnterpriseLayout = ({ children }: PropsWithChildren) => {
  return (
    <UserProvider>
      <TooltipProvider>
        <SidebarProvider>
          <AppSidebar />
          <SidebarInset className="!min-w-0 h-screen">
            <HeaderUser />
            <div className="flex-1 bg-[#F5F6FA] px-4 md:px-[30px] pb-6 pt-[88px]">
              {children}
            </div>
          </SidebarInset>
        </SidebarProvider>
      </TooltipProvider>
    </UserProvider>
  )
}

export default EnterpriseLayout
